import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const CompanyProfile = () => {
  return (
    <>
      <div className="page-header">
        <Container>
          <div className="text-center">
            <h1 style={{ 
              fontSize: '3rem',
              fontWeight: '800',
              color: 'white',
              marginBottom: '1rem'
            }}>
              Company Profile
            </h1>
            <p style={{ fontSize: '1.2rem', color: 'rgba(255,255,255,0.9)', marginBottom: '2rem' }}>
              Leading thermal solutions provider since 2007 
            </p>
            <a 
              href="/doc/COMPANY PROFILE ALLIED THERMAL-1.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-outline-light btn-lg"
            >
              📄 Download Company Profile
            </a>
          </div>
        </Container>
      </div>

      <section className="section-padding">
        <Container>
          <Row className="align-items-center mb-5">
            <Col lg={6}>
              <div style={{ marginBottom: '2rem' }}>
                <h2 style={{ 
                  fontSize: '2.8rem',
                  fontWeight: '800',
                  background: 'linear-gradient(135deg, #1e40af, #dc2626)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  marginBottom: '2rem'
                }}>
                  About Allied Thermal
                </h2>
              </div>
              <div style={{
                background: 'white',
                padding: '2.5rem',
                borderRadius: '20px',
                boxShadow: '0 15px 40px rgba(0,0,0,0.1)',
                border: '1px solid rgba(59, 130, 246, 0.1)'
              }}>
                <p className="mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                  <strong style={{ color: '#dc2626' }}>Established in 2007</strong>, Allied Thermal has been engaged as a 
                  Wholesaler, Distributor, Importer, Trader, Exporter and Manufacturer 
                  of Industrial Furnace Plant and Machinery, Pollution Control System, 
                  Forming Machine, Pulse Jet Bag Filter House, White Metal Ingots and many more.
                </p>
                <p className="mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                  We have been offering an eminent range of these items at highly 
                  competitive and economical market prices to our customers within 
                  the stipulated time frame.
                </p>
                <div style={{
                  background: 'linear-gradient(135deg, rgba(30, 64, 175, 0.05), rgba(220, 38, 38, 0.05))',
                  padding: '1.5rem',
                  borderRadius: '12px',
                  border: '2px solid rgba(30, 64, 175, 0.1)'
                }}>
                  <p style={{ fontSize: '1.1rem', lineHeight: '1.7', marginBottom: 0 }}>
                    We operate under the capable mentorship of <strong style={{ color: '#1e40af' }}>Mr. Ajay Jaiswal</strong>, 
                    whose guidance has enabled us to present the most capable set of 
                    items within the earnest time frame.
                  </p>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <div style={{
                background: 'white',
                padding: '1.5rem',
                borderRadius: '20px',
                boxShadow: '0 15px 40px rgba(0,0,0,0.1)'
              }}>
                <img
                  src="/images/ALUMINIUM_MELTING/Al melting furnace.jpg"
                  alt="Allied Thermal Manufacturing Facility"
                  style={{
                    width: '100%',
                    height: '400px',
                    objectFit: 'cover',
                    borderRadius: '15px'
                  }}
                />
                <div className="text-center mt-3">
                  <h5 style={{ fontWeight: '700', color: '#1e293b' }}>
                    🏭 Allied Thermal Manufacturing Excellence
                  </h5>
                  <p style={{ color: '#64748b', fontSize: '0.9rem' }}>
                    State-of-the-art manufacturing facility with advanced thermal solutions
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="section-padding company-profile-section">
        <Container>
          <div className="section-title">
            <h2>Company Factsheet</h2>
            <p>Key business information and credentials</p>
          </div>
          <Row>
            <Col lg={6} className="mb-4">
              <div className="bg-white p-4 rounded shadow-sm h-100">
                <h4 className="mb-3">Basic Information</h4>
                <div className="mb-2"><strong>Nature of Business:</strong> Trader - Wholesaler/Distributor</div>
                <div className="mb-2"><strong>Additional Business:</strong> Factory/Manufacturing, Export</div>
                <div className="mb-2"><strong>Company CEO:</strong> Ajay Jaiswal</div>
                <div className="mb-2"><strong>Total Employees:</strong> Up to 10 People</div>
                <div className="mb-2"><strong>Legal Status:</strong> Proprietorship</div>
                <div className="mb-2"><strong>Annual Turnover:</strong> Under ₹5 Crore</div>
                <div className="mb-2"><strong>GST Partner:</strong> Alpana Jaiswal</div>
              </div>
            </Col>
            <Col lg={6} className="mb-4">
              <div className="bg-white p-4 rounded shadow-sm h-100">
                <h4 className="mb-3">Statutory Profile</h4>
                <div className="mb-2"><strong>Import Export Code (IEC):</strong> AJSPJ7658L</div>
                <div className="mb-2"><strong>GST No.:</strong> 06AJSPJ7658L1ZC</div>
                <div className="mb-2"><strong>Banker:</strong> ICICI Bank</div>
                <div className="mb-2"><strong>Export Percentage:</strong> 85%</div>
                <div className="mb-3"><strong>Established:</strong> 2007</div>
                
                <h5 className="mt-4 mb-3">Payment & Shipment</h5>
                <div className="mb-2"><strong>Payment Modes:</strong> Cash, Credit Card, DD, Cheque</div>
                <div className="mb-2"><strong>Shipment Mode:</strong> Road, Rail, Sea, Air</div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="section-padding">
        <Container>
          <div className="section-title">
            <h2>Our Achievements</h2>
            <p>Milestones that define our excellence</p>
          </div>
          <Row>
            <Col lg={3} md={6} className="mb-4">
              <div className="stats-card">
                <span className="stats-number">17+</span>
                <p>Years of Excellence</p>
              </div>
            </Col>
            <Col lg={3} md={6} className="mb-4">
              <div className="stats-card">
                <span className="stats-number">500+</span>
                <p>Products Delivered</p>
              </div>
            </Col>
            <Col lg={3} md={6} className="mb-4">
              <div className="stats-card">
                <span className="stats-number">85%</span>
                <p>Export Business</p>
              </div>
            </Col>
            <Col lg={3} md={6} className="mb-4">
              <div className="stats-card">
                <span className="stats-number">10+</span>
                <p>Team Members</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="section-padding company-profile-section">
        <Container>
          <Row>
            <Col lg={6} className="mb-4">
              <h3>Our Mission</h3>
              <p>
                To provide high-quality industrial furnace plants, machinery, and 
                pollution control systems at competitive prices while maintaining 
                excellence in customer service and timely delivery.
              </p>
            </Col>
            <Col lg={6} className="mb-4">
              <h3>Our Vision</h3>
              <p>
                To be the leading manufacturer and supplier of thermal solutions 
                in India, expanding our export reach while maintaining our 
                commitment to quality and innovation.
              </p>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col lg={12}>
              <h3>Core Business Areas</h3>
              <Row>
                <Col md={4} className="mb-3">
                  <div className="service-card">
                    <h5>Manufacturing</h5>
                    <p>Industrial Furnace Plants, Pollution Control Systems, and specialized machinery.</p>
                  </div>
                </Col>
                <Col md={4} className="mb-3">
                  <div className="service-card">
                    <h5>Trading & Distribution</h5>
                    <p>Wholesale distribution of thermal equipment and white metal ingots.</p>
                  </div>
                </Col>
                <Col md={4} className="mb-3">
                  <div className="service-card">
                    <h5>Import & Export</h5>
                    <p>International trade with 85% export business across multiple countries.</p>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default CompanyProfile;
